module.exports = __webpack_public_path__ + "static/media/right-arrow.b4652b3f.svg";